<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.55273 2.55286L9.44703 9.44715" stroke="currentColor"/>
<path d="M9.44727 2.55286L2.55297 9.44715" stroke="currentColor"/>
</svg>
